import React, { useState } from 'react';
import {Link, useNavigate} from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button, Form } from 'react-bootstrap';
import {forgotPassword} from "../../lib/api/user";

const ForgetPasswordForm = () => {
    const navigate = useNavigate();
  // State
  const [email, setEmail] = useState('');

  // Handler
   const handleSubmit = async (e, button) => {
      e.preventDefault();
      if (email) {
          try {
              button.disabled = true
              const options = {email: email};
              const row = await forgotPassword(options);
              toast.success(`An email is sent to ${email} with password reset link`, {
                  theme: 'colored'
              });
              button.disabled = false
              navigate('/authentication/simple/login');
          } catch (e) {
              button.disabled = false;
              toast.error(`An email is sent to ${email} nije dobar aktivacioni kod`, {
                  theme: 'colored'
              });
          }


      }
  };

  return (
    <Form className="mt-4">
      <Form.Group className="mb-3">
        <Form.Control
          placeholder={'Email address'}
          value={email}
          name="email"
          onChange={({ target }) => setEmail(target.value)}
          type="email"
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Button className="w-100" type="submit" disabled={!email} onClick={(e) => handleSubmit(e, e.currentTarget)}>
          Send reset link
        </Button>
      </Form.Group>

      <Link className="fs-10 text-600" to="#!">
        I can't recover my account using this page
        <span className="d-inline-block ms-1"> &rarr;</span>
      </Link>
    </Form>
  );
};

export default ForgetPasswordForm;
